// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowLeft from '../_raw/ui/icon_arrow_left.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowLeft);
